module.exports = __webpack_public_path__ + "static/img/fu_tit02.bc6860d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/fu_tit02.png
// module id = 116
// module chunks = 6